const zh = {
  nav: { home: "首页", about: "关于我们", activities: "活动", booking: "预订", contact: "联系我们", book_now: "立即预订" },
  hero: { eyebrow: "罗弗敦 · 北极挪威", title: "从海上体验罗弗敦", subtitle: "搭乘 Viksund 340 St. Cruz 的专属北极冒险", cta_primary: "立即预订", cta_secondary: "探索活动", scroll: "向下滚动探索" },
  intro: { eyebrow: "我们的故事", title: "小公司。大海。难忘时刻。", body: "我们是一家扎根罗弗敦的小型家族运营商。凭借数十年的本地经验和一艘高端 Viksund 340 St. Cruz,我们为您打造远离人群的宁静、专属海上旅程 — 由潮汐、天气与北极光引领。", cta: "了解更多" },
  highlights: { eyebrow: "我们提供", title: "由海洋塑造的体验", subtitle: "根据季节量身定制的私人行程 — 从深海捕鱼到午夜天空下追逐北极光。", see_all: "查看所有活动" },
  testimonials: { eyebrow: "宾客故事", title: "来自世界各地旅人的喜爱", items: [
    { name: "Sophie L.", country: "法国", quote: "整趟旅程中最神奇的一夜。寂静的峡湾、私人船只、北极光在水面上闪耀。无法言喻。" },
    { name: "Markus & Elena", country: "德国", quote: "真正的本地体验。船长熟悉每一处海湾与岛屿。我们捕鱼、欢笑,还近距离看到海雕。" },
    { name: "Daniel K.", country: "美国", quote: "高端、安全且极具个人化。Viksund 340 St. Cruz 是一艘美丽的船,船员让我们宾至如归。" },
  ]},
  about: { eyebrow: "关于我们", title: "诞生于罗弗敦海岸",
    paragraphs: [
      "我们在罗弗敦提供独特且安全的海上体验,尤其关注儿童与青少年。在一个海洋知识与敬意愈发重要的时代,我们希望让年轻人获得能培养理解力、掌控力与对海上生活热爱的体验。",
      "我们的服务涵盖丰富的活动与体验。包括运动垂钓、潜水以及以自然与学习为重点的\"蓝色之旅\";同时提供定制体验,如婚礼出海、北极光之旅以及参观水产养殖场,深入了解海洋养殖业。",
      "对于自然爱好者,我们提供观赏海雕与观鲸之旅、冲浪以及更具冒险感的海上活动,适合追求刺激的您。我们也欢迎希望体验北方粗犷与壮丽自然的国际宾客 — 涵盖海浪与带有极限色彩的海上活动。",
      "此外,我们提供海上出行服务(海上出租)、团体与企业游,以及与本地合作伙伴联合推出的含住宿与餐饮的行程。我们高度重视与旅游业及邮轮业的协作,打造完整且难忘的体验。",
      "对于经博德(Bodø)抵达的宾客:我们的船从罗弗敦到博德仅需 45 分钟,因此我们可以直接在博德接送客人 — 流畅、快速,无需多余中转。",
      "我们还提供无人机拍摄服务。如果您希望为出海行程留下电影级航拍影像 — 高空中的海雕、峡湾中的船只、北极光或冲浪画面 — 我们可以将专业航拍纳入您的行程。",
      "这只是一个令人期待的项目的开始,我们将持续与旅游业其他合作伙伴共同开发新的产品。",
    ],
    boat_title: "Viksund 340 St. Cruz",
    boat_body: "我们的旗舰是 Viksund 340 St. Cruz — 一艘挪威制造的高端船只,以出色的适航性、舒适和静谧著称。完全供暖的舱室、全景窗、现代导航,以及充足的甲板空间供钓鱼、摄影或纯粹欣赏风景。",
    values: [
      { title: "本地知识", body: "在罗弗敦出生成长。熟悉每座岛屿、每道洋流。" },
      { title: "小型 & 私密", body: "最多 10 位宾客。始终如同您的私人包船。" },
      { title: "安全至上", body: "持证船长、现代装备、提供全天候服装。" },
      { title: "原汁原味", body: "没有旅游陷阱。真正的罗弗敦,由海洋与光线塑造。" },
    ]},
  activities: { eyebrow: "体验", title: "选择您的冒险", subtitle: "从午夜阳光巡游到冬季观鲸 — 每次出行都是私人、灵活且由本地专家带领。", duration: "时长", book: "立即预订", details: "详情" },
  booking: { eyebrow: "预订您的体验", title: "发送预订申请", subtitle: "告诉我们您的梦想,我们将在 24 小时内回复您可用时段与个性化方案。",
    fields: { name: "全名", email: "电子邮箱", phone: "电话", guests: "人数", activity: "活动", date: "首选日期", message: "留言(可选)", message_ph: "告诉我们关于您的团队、饮食需求、希望看到的事物……", pick_date: "选择日期", pick_activity: "选择活动" },
    submit: "发送预订申请", sending: "发送中...", success_title: "已收到预订申请", success_body: "谢谢!我们将很快与您联系并告知可用时段。", error_title: "出错了", error_body: "请重试或直接与我们联系。" },
  contact: { eyebrow: "联系我们", title: "我们就在海边", subtitle: "联系我们获取定制行程、团队预订或任何关于罗弗敦的问题。", phone: "电话", email: "邮箱", address: "地址", address_value: "Havnegata 1, 8300 Svolvær, 罗弗敦, 挪威", form_title: "给我们留言", form_name: "您的姓名", form_email: "邮箱", form_subject: "主题", form_message: "留言", form_submit: "发送留言", sending: "发送中...", success: "谢谢 — 我们将尽快回复。", error: "无法发送留言,请重试。" },
  gallery: { eyebrow: "相册", title: "海上时刻", subtitle: "来自我们罗弗敦航程的真实影像。" },
  faq: { eyebrow: "常见问题", title: "出发前须知", items: [
    { q: "行程包含什么?", a: "全部安全装备、保温救生服、钓鱼装备(钓鱼行程)、热饮与持证本地船长带队。" },
    { q: "何时是观赏北极光的最佳时间?", a: "9 月末至 4 月初。晴朗黑夜几率最高 — 在海上还可享受无遮挡的 360° 视野。" },
    { q: "需要经验吗?", a: "不需要。行程适合所有水平。大多数行程欢迎儿童参与 — 预订时请告知。" },
    { q: "天气不好怎么办?", a: "安全第一。若条件不安全,我们将改期或全额退款。罗弗敦天气变化快,我们灵活应对。" },
    { q: "团队规模多大?", a: "Viksund 340 St. Cruz 最多 10 位宾客。大多数行程为私人或半私人。" },
  ]},
  footer: { tagline: "罗弗敦,挪威的专属海上体验。", explore: "探索", contact: "联系", follow: "关注我们", rights: "保留所有权利。" },
  extras: {
    boat_banner_title: "安静。稳健。北欧匠心。",
    boat_banner_body: "供暖舱室、全景窗、宽敞甲板,可钓鱼、摄影,或纯粹欣赏美景。",
    boat_banner_cta: "了解更多关于船的信息",
    home_cta_title: "准备好出海一天了吗?我们为您量身打造。",
    booking_pick_date_err: "请选择日期。",
    booking_pick_activity_err: "请选择一项活动。",
    booking_reply_note: "我们将在 24 小时内回复您可用时段与价格。",
    booking_charter_label: "私人包船",
    booking_charter_title: "灵活预订,专属跟进。",
    booking_charter_1: "恶劣天气可免费取消",
    booking_charter_2: "每趟最多 10 位宾客",
    booking_charter_3: "持证本地船长",
    booking_charter_4: "所有安全装备齐备",
    about_values_eyebrow: "我们的价值观",
    about_values_title: "我们坚守的理念",
    about_cta_title: "让我们为您规划行程?",
    nav_language: "语言",
    stat_arctic_lofoten: "北极罗弗敦",
    stat_viknes_vessel: "Viksund 船",
    stat_max_guests: "最多宾客",
    stat_activities: "体验项目",
    stat_length: "船长",
    stat_berths: "铺位",
    stat_days_year: "年运营天数",
  },
};
export default zh;
